// extracted by mini-css-extract-plugin
export default {"container":"Search_container__aG-kZ","results":"Search_results__+jx1P","error":"Search_error__LNvfC","checkbox":"Search_checkbox__pJnN9","breathing":"Search_breathing__Drcvt"};